import BackendService from './BackendService';

class FeedbackService {
  /**
   * Fetch feedbacks for the current shop.
   * Assumes BackendService adds the required shop-id and auth headers.
   */
  async getFeedbacks() {
    return BackendService.getData('/feedbacks/');
  }

  /**
   * Update feedback status.
   */
  async updateFeedbackStatus(feedbackId, data) {
    return BackendService.patch(`/feedbacks/${feedbackId}/`, data);
  }

  /**
   * Submit a new feedback.
   * Uses a public endpoint to avoid auth requirements.
   */
  async submitFeedback(shopId, data) {
    return BackendService.postData(`/public/feedbacks/${shopId}/`, data);
  }
}

const feedbackService = new FeedbackService();
export default feedbackService;
